export default __webpack_public_path__ + "static/media/News.812d7db6.svg";